export default start => {
  start();
};
